import ProductHits from "./components/ProductHits";
import PageHits from "./components/PageHits";
import IndexSelector, { IndexSelectorProps } from "./components/IndexSelector";
import { useSearchBox } from "react-instantsearch";
import { useIndexName } from "../search-results/components/IndexNameProvider";
import { cn } from "../utils/cn";
import { searchIndexes } from "../search-shared/client";
import ArticleHits from "./components/ArticleHits";
import { CollectionsHits, BrandsHits } from "./components/CollectionBrandsHits";

export default  function InstantSearchResults() {
  const { query } = useSearchBox();
  const { indexName: currentIndex, setIndexName } = useIndexName();

  const showHelpFaq = window.algoliaShopify?.config?.show_help_faq;

  const indexChangeHandler = (value: string) => {
    setIndexName(value);
  };

  const indexOptions: IndexSelectorProps["options"] = [
    { indexName: searchIndexes.RECOMMENDED_PRODUCTS, label: 'Products' },
    { indexName: searchIndexes.ARTICLES, label: 'Journal Articles' },
    ...(showHelpFaq ? [{ indexName: searchIndexes.PAGES, label: 'Help & Faq' }] : []),
  ];

  const indexOptionsMobile = [
    { indexName: searchIndexes.RECOMMENDED_PRODUCTS, label: 'Products' },
    { indexName: searchIndexes.COLLECTIONS, label: 'Collections' },
    { indexName: searchIndexes.BRAND_PAGES, label: 'Brands' },
    { indexName: searchIndexes.ARTICLES, label: 'Journal Articles' },
    ...(showHelpFaq ? [{ indexName: searchIndexes.PAGES, label: 'Help & Faq' }] : []),
  ];
  
  if (!query) {
    return false;
  }

  return (
    <div className={cn(
      "tw-h-searchHeight tw-overflow-y-scroll xl:tw-overflow-y-visible",
      "xl:tw-grid xl:tw-grid-cols-[minmax(max-content,330px)_1fr] tw-gap-x-3",
    )}>
      {/* LEFT COLUMN */}
      <div>
        <div className="sm:tw-space-y-5 xl:tw-h-searchHeight xl:tw-space-y-0 xl:tw-pl-2 xl:tw-pr-10 xl:tw-bg-search-grey/10">
          {/* INDEX SELECTOR */}
          <div className="xl:tw-hidden">
            <IndexSelector options={indexOptionsMobile} onChange={indexChangeHandler} defaultSelectedIndex={currentIndex} />
          </div>

          <div className="tw-hidden xl:tw-block">
            <IndexSelector options={indexOptions} onChange={indexChangeHandler} defaultSelectedIndex={currentIndex} />
          </div>

          <div className="sm:tw-space-y-2 tw-text-search-grey xl:tw-text-black">
            <section className="tw-mt-6 xl:tw-mt-20">
              <div className="xl:[&_.CollectionBrandsHits]:tw-hidden">
                <CollectionsHits />
              </div>

              <div className="[&_.CollectionBrandsHits]:tw-hidden xl:[&_.CollectionBrandsHits]:tw-block">
                <CollectionsHits showOnIndex={(searchIndexes.RECOMMENDED_PRODUCTS || searchIndexes.COLLECTIONS)} />
              </div>
            </section>

            <section className="tw-mt-6 xl:tw-mt-20">
              <div className="xl:[&_.CollectionBrandsHits]:tw-hidden">
                <BrandsHits />
              </div>

              <div className="[&_.CollectionBrandsHits]:tw-hidden xl:[&_.CollectionBrandsHits]:tw-block">
                <BrandsHits showOnIndex={(searchIndexes.RECOMMENDED_PRODUCTS || searchIndexes.BRAND_PAGES)} />
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* RIGHT COLUMN / PRODUCTS */}
      <div className={cn(
        "tw-h-searchHeight xl:tw-overflow-y-scroll",
      )}>
        {currentIndex === searchIndexes.RECOMMENDED_PRODUCTS && (
          <>
            <h3 className="tw-mt-5 tw-text-sm tw-text-search-grey xl:tw-sr-only">Product Results</h3>

            <div className="tw-mt-2 xl:tw-mt-0">
              <ProductHits />
            </div>
          </>
        )}

        <ArticleHits />
        <PageHits />
      </div>
    </div>
  );
}